import StatCard from '../../dashboard/components/StatCard';
import type { AdminWhatsappStats } from '../../../domain/superadmin/types';

interface WhatsappStatsCardsProps {
    stats: AdminWhatsappStats;
}

const formatNumber = (value: number) => value.toLocaleString('pt-BR');

export function WhatsappStatsCards({ stats }: WhatsappStatsCardsProps) {
    return (
        <section aria-label="Indicadores" className="mb-s5 grid grid-cols-1 gap-s3 sm:grid-cols-2 lg:grid-cols-4">
            <StatCard
                title="Total"
                value={formatNumber(stats.total)}
                change={0}
                period="instâncias"
                baseValue="-"
                icon="whatsapp"
                accent="brand"
            />
            <StatCard
                title="Conectados"
                value={formatNumber(stats.connected)}
                change={0}
                period="ativos"
                baseValue="-"
                icon="link"
                accent="success"
            />
            <StatCard
                title="Desconectados"
                value={formatNumber(stats.disconnected)}
                change={0}
                period="offline"
                baseValue="-"
                icon="unlink"
            />
            <StatCard
                title="QR / Conectando"
                value={formatNumber(stats.pending)}
                change={0}
                period="pendentes"
                baseValue="-"
                icon="smartphone"
            />
        </section>
    );
}
